'use es6';

import ImmutableModel from 'DesignData/models/ImmutableModel';

class CustomWidgetTranslations extends ImmutableModel {
  /**
   * @constructor
   */
  constructor(props) {
    return super(props);
  }

}

CustomWidgetTranslations.REQUIRED_FIELDS = ['masterLanguage', 'messages'];
CustomWidgetTranslations.DEFAULT_FIELDS = {
  messages: {}
};
export default CustomWidgetTranslations;